/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import BenchlingCollection from 'BenchlingCollection';
import {Tag} from 'folder-items/FileConstants';

import TagModel from './Tag';

class Tags extends BenchlingCollection<TagModel> {
  attributeName!: string;

  static initClass(): void {
    this.prototype.model = TagModel;
    this.prototype.attributeName = 'tags';
  }

  override initialize(models: Array<Tag>, options: {sequenceId: number}): void {
    super.initialize(models, options);
    this.on('change add remove', function (this: Tags): void {
      this.trigger('change:tags');
    });
  }
}
Tags.initClass();

export default Tags;
